import { render, staticRenderFns } from "./msg-content.vue?vue&type=template&id=65135157&scoped=true&"
import script from "./msg-content.vue?vue&type=script&lang=js&"
export * from "./msg-content.vue?vue&type=script&lang=js&"
import style0 from "./msg-content.vue?vue&type=style&index=0&id=65135157&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65135157",
  null
  
)

export default component.exports